import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import '../App.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import ProductCard from '../components/productCard'; 

const CarouselComponent = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [slidesToShow, setSlidesToShow] = useState(2); // default to 2 slides

  const carouselItems = [
    {
      src: '/images/WHITE BREAD 24oz.jpg',
      us: '1 oz Slice' ,
      alt: 'WHITE BREAD 24 oz',
      title: 'WHITE BREAD 24 oz',
      description: 'WHITE BREAD 24 oz',
      uom: 'CASE OF 20 LOAVES',
      vendorPartNumber: 'A-02803',
      pkgSize: '24oz',
      stockNumber: '892001E128215',
      image: '/images/WHITE BREAD 24oz.jpg', 
    },
    {
      src: "/images/RAISIN BREAD.jpg",
      us: "2 lbs Loaf" ,
      alt: "RAISIN BREAD",
      title: "RAISIN BREAD", 
      description:"RAISIN BREAD" ,
      uom: "CASE OF 8 LOAVES",
      vendorPartNumber:"UC-RB100" ,
      pkgSize: "16 lbs",
      stockNumber: "892001E360170",
      image: "/images/RAISIN BREAD.jpg",
    },
    {
      src: "/images/F-2059.jpg",
      us: "2oz Bun" ,
      alt: "HAMBURGER BUNS 4 INCH",
      title: "HAMBURGER BUNS 4 INCH", 
      description:"HAMBURGER BUNS 4 INCH" ,
      uom: "CASE OF 144 BUNS",
      vendorPartNumber:"F-2059",
      pkgSize: "18 lbs",
      stockNumber: "892001E128211",
      image: "/images/F-2059.jpg",
    },

    {
      src: '/images/9600.png',
      us: '2oz Bun' ,
      alt: 'HOTDOG BUNS',
      title: 'HOTDOG BUNS',
      description: 'HOTDOG BUNS',
      uom: 'CASE OF 216 BUNS',
      vendorPartNumber: 'F-2600',
      pkgSize: '12 buns',
      stockNumber: '892001E128212',
      image: '/images/9600.png', 
    },
    {
      src: "/images/SB28210.jpg",
      us: "1oz Roll" ,
      alt: "Dinner Rolls",
      title: "Dinner Rolls", 
      description:"BRIOCHE, PULL APART" ,
      uom: "CASE OF 80 ct",
      vendorPartNumber:"SB28210" ,
      pkgSize: "6 lbs",
      stockNumber: "892001E221833",
      image: "/images/SB28210.jpg",
    },
    {
      src: '/images/BQ801-7IW.jpg',
      us: '4.5oz Slice' ,
      alt: 'CARROT CAKE',
      title: 'CARROT CAKE',
      description: 'CARROT CAKE',
      uom: 'SINGLE BOX, 7 WEDGES',
      vendorPartNumber: 'BQ801-IW',
      pkgSize: '2 lbs',
      stockNumber: '892001E221668',
      image: '/images/BQ801-7IW.jpg',
    },
    {
      src: "/images/BQ832-7IW.jpg",
      us: "4oz Slice" ,
      alt: "RASPBERRY CHEESECAKE",
      title: "RASPBERRY CHEESECAKE", 
      description:"RASPBERRY CHEESECAKE" ,
      uom: "SINGLE BOX, 7 WEDGES",
      vendorPartNumber:"BQ832-7IW" ,
      pkgSize: "2 lbs",
      stockNumber: "892001E221669",
      image: "/images/BQ832-7IW.jpg",
    },{
      src: "/images/BQS801-7IW.jpg",
      us: "4oz Slice" ,
      alt: "DOUBLE CHOCOLATE CAKE",
      title: "DOUBLE CHOCOLATE CAKE", 
      description:"DOUBLE CHOCOLATE CAKE" ,
      uom: "SINGLE BOX, 7 WEDGES",
      vendorPartNumber:"BQS801-7IW",
      pkgSize: "2 lbs",
      stockNumber: "892001E221670",
      image: "/images/BQS801-7IW.jpg",
    },
    {
      src: "/images/BQS802-7IW.jpg",
      us: "4oz Slice" ,
      alt: "GERMAN CHOCOLATE CAKE",
      title: "GERMAN CHOCOLATE CAKE", 
      description:"GERMAN CHOCOLATE CAKE" ,
      uom: "SINGLE BOX, 7 WEDGES",
      vendorPartNumber:"BQS802-7IW" ,
      pkgSize: "2 lbs",
      stockNumber: "892001E127799",
      image: "/images/BQS802-7IW.jpg",
    },
    {
      src: "/images/DAB003-36TS.jpg",
      us: "1.5oz Pastry" ,
      alt: "ASSORTED MINI ROUND DANISH",
      title: "ASSORTED MINI ROUND DANISH", 
      description:"ASSORTED MINI ROUND DANISH" ,
      uom: "SINGLE BOX, 36 ct",
      vendorPartNumber:"DAB003-36TS" ,
      pkgSize: "3 lbs",
      stockNumber: "892001E221518",
      image: "/images/DAB003-36TS.jpg",
    },
    {
      src: "/images/DAB023-48TS.jpg",
      us: "1oz Pastry" ,
      alt: "CLASSIC MINI ASSORTMENT DANISH",
      title: "CLASSIC MINI ASSORTMENT", 
      description:"CLASSIC MINI ASSORTMENT" ,
      uom: "SINGLE BOX, 48 CT",
      vendorPartNumber:"DAB023-48TS" ,
      pkgSize: "3 lbs",
      stockNumber: "892001E127856",
      image: "/images/DAB023-48TS.jpg",
    },
    {
      src: "/images/MUBASST-M-TC-16TS.jpg",
      us: "2.5oz Muffin" ,
      alt: "ASSORTED MUFFINS MEDIUM",
      title: "ASSORTED MUFFINS MEDIUM", 
      description:"ASSORTED MUFFINS MEDIUM" ,
      uom: "SINGLE BOX, 16 ct",
      vendorPartNumber:"MUBASST-M-TC-16TS" ,
      pkgSize: "3 lbs",
      stockNumber: "892001E127815",
      image: "/images/MUBASST-M-TC-16TS.jpg",
    },
  ];

  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth < 732) {
        setSlidesToShow(1);
      } else {
        setSlidesToShow(2);
      }
    };

    updateSlidesToShow(); // Initial check
    window.addEventListener('resize', updateSlidesToShow); // Listen for window resize

    return () => {
      window.removeEventListener('resize', updateSlidesToShow); // Cleanup listener on component unmount
    };
  }, []);

  const settings = {
    infinite: true,
    speed: 20000, // Slower speed to allow for smooth continuous scrolling
    slidesToShow: slidesToShow,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 0, // 0 milliseconds for continuous movement
    cssEase: 'linear', // Linear easing for a constant speed
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <div className=''>
      {selectedItem ? (
        <ProductCard item={selectedItem} />
      ) : (
        <Slider {...settings}>
  {carouselItems.map((item, index) => (
    <div key={index} onClick={() => setSelectedItem(item)} style={{ cursor: 'pointer', position: 'relative' }} className='carousel-item img'>
      <div className=' w-100 border rounded-circle border-5 shadow-lg position-absolute' style={{ top: 0, left: 0, right: 0, bottom: 0, zIndex: 1 }}></div>
      <img
        className="d-block w-100 rounded-circle p-2"
        src={item.src}
        alt={item.alt}
        style={{ position: 'relative', zIndex: 0 }}
      />
      <p className='text-center p-1 custom-font font-weight-bold'>{item.description}</p>
    </div>
  ))}
</Slider>

      )}
    </div>
  );
};

export default CarouselComponent;
